export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9173.1649d998.jpg";